import { Navigate, Route, Routes } from 'react-router-dom';

import { Layout } from './components/Layout';
import { Landing } from './pages/Landing';
import { Inbox } from './pages/Inbox';
import { Thread } from './pages/Thread';
import { Compose } from './pages/Compose';
import { Settings } from './pages/Settings';
import { Profile } from './pages/Profile';
import { useSession } from './hooks/useSession';

function RequireSession({ children }: { children: JSX.Element }) {
  const { profile, loading } = useSession();
  if (loading) return <div className="page" />;
  return profile ? children : <Navigate to="/" replace />;
}

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Landing />} />
        {/* Public and deliberately outside RequireSession: a link from someone's
            bio has to work for a stranger who has never connected a wallet. */}
        <Route path="w/:handle" element={<Profile />} />
        <Route
          path="inbox"
          element={
            <RequireSession>
              <Inbox />
            </RequireSession>
          }
        />
        <Route
          path="thread/:id"
          element={
            <RequireSession>
              <Thread />
            </RequireSession>
          }
        />
        <Route
          path="compose"
          element={
            <RequireSession>
              <Compose />
            </RequireSession>
          }
        />
        <Route
          path="settings"
          element={
            <RequireSession>
              <Settings />
            </RequireSession>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
